// extracted by mini-css-extract-plugin
module.exports = {"card":"LoadDetailsCard_card__2jTj7"};